<style lang="scss" scoped>
  @import '../../../sass/variables';

  .lead-list {
    padding: 24px 24px 8px;
    border-radius: 24px;
    background-color: $salesflow-bg-content;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
    margin-bottom: 52px;
  }

  .card {
    overflow: visible;
    margin-bottom: 0px;

    .card-body {
      background-color: $salesflow-bg-body;
      outline: 1px solid $salesflow-outline-gray-medium;
      border-radius: 12px;

      input:not([type="submit"], .date-range-input), select, span:not(.advanced-filter, .date-range-input) {
        padding: 7px, 12px, 7px, 12px;
        border-radius: 8px;
        border: 1px solid $salesflow-outline-gray-medium;
        background-color: $salesflow-bg-content;
        color: $salesflow-font-dark;
        font-size: 0.875rem;
        font-weight: 400;

        &::placeholder {
          color: $salesflow-font-gray-light;
        }
      }

      ::v-deep span.form-control.readonly-theme .vue-daterange-picker {
        display: block;

        .reportrange-text {
          border: 1px solid $salesflow-outline-gray-medium;
          border-radius: 8px;

          .input-group {
            width: 100%;
            display: flex;
            align-items: center;

            input {
              flex: 1;
            }
          }
        }

        .daterangepicker {
          top: 48px;
        }
      }

      select {
        font-size: 0.875rem;
        appearance: none;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: right 1rem center;
        background-size: 1em;

        option {
          padding-top: 20px;

          &:hover {
            background-color: red;
          }
        }
      }
    }

    #form-filter {
      .filter-header {
        h4 {
          font-size: 1.25rem;
          color: $salesflow-font-gray;
          line-height: 130%;
        }

        span.advanced-filter {
          outline: 0;
          font-size: 0.875rem;
          background-color: transparent;

          a {
            font-weight: 500;
            color: $salesflow-primary;
          }
        }
      }

      #submit-button {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 12px 32px;
        background: $salesflow-primary;
        border: 1px solid $salesflow-primary;
        border-radius: 14px;
      }
    }
  }

  .general-filters {
    margin-bottom: 24px;
    align-items: center;
  }

  .row.board {
    padding: 0;
    margin-top: 16px;
    margin-bottom: 0;
    border: 1px solid $salesflow-outline-gray-medium;
    background-color: $salesflow-bg-content;
    border-radius: 24px;
    overflow: hidden;

    .table-responsive {
      margin: 0;
      height: 56vh;
      border: 4px solid transparent;
      border-left: 10px solid transparent;
      border-top: 10px solid white;
      background-color: white;

      table {
        overflow-x: scroll;
        thead {
          background-color: white;

          th {
            position: sticky;
            top: 0px;
            background-color: white;
            border-top: 0px;
            font-weight: 700;
            color: $salesflow-font-gray;
            font-size: 0.75rem;
            line-height: 125%;
            padding: 12px 15px;

            a {
              color: $salesflow-font-gray;
              font-size: 0.75rem;
            }
          }
        }
        tbody {
          background-color: white;

          tr {
            td {
              font-weight: 400;
              font-size: 0.75rem;
              line-height: 125%;

              .lead-name {
                font-weight: 600;
              }

              .lead-owner {
                font-weight: 500;
              }
            }
          }
        }
      }
    }
  }
</style>

<script>
import { BButtonGroup, VBTooltip } from 'bootstrap-vue';

export default {
  components: {
    BButtonGroup,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  data () {
    return {
      checked: [],
      filters: false,
      select: {
        automation: null,
      },
    };
  },

  computed: {
    hasChecked () {
      return this.checked.length > 1;
    },

    allSelected () {
      return this.hashes.length == this.checked.length;
    },
  },

  props: ['user', 'hashes'],

  methods: {
    toggleAdvancedFiltersButton () {
      Bus.$emit('advancedFiltersButtonToggled');
    },

    toggleCreateLeadButton () {
      Bus.$emit('createLeadButtonToggled');
    },

    toggleCreateDealButton (forLead) {
      Bus.$emit('createDealButtonToggled', forLead);
    },

    toggleImportLeadButton () {
      Bus.$emit('importLeadButtonToggled');
    },

    openUpgradePlanModal () {
      Bus.$emit('openUpgradePlanModal');
    },

    check (hash) {
      if (_.contains(this.checked, hash)) {
        this.checked.splice(this.checked.indexOf(hash), 1);
      } else {
        this.checked.push(hash);
      }
    },

    selectAll () {
      const { allSelected } = this;

      if (allSelected) {
        return this.checked.splice(0, this.checked.length);
      }

      this.checked = [].concat(this.hashes);
    },

    isChecked (hash) {
      return this.checked.indexOf(hash) !== -1;
    },

    release () {
      console.log(this.checked);
    },
  },
};
</script>
